module.exports = __webpack_public_path__ + "img/Illustrations_Manage-Library@3x.f4c020f9.png";